import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';

export const childTokenGuard: CanActivateFn = (route: ActivatedRouteSnapshot, state: RouterStateSnapshot):
	Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree => {
	return localStorage.getItem('simulation_token') == null ? inject(Router).createUrlTree(['/login'],{ queryParams: { returnUrl: state.url }}) : true;
};
